var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntensidadPercibidaBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,2C117.23,2,4.35,113.4,2,251.68a5,5,0,0,0-.3,1.64,4.92,4.92,0,0,0,.26,1.5c0,.42,0,.83,0,1.24C2,396.28,115.77,510,256,510S510.05,396.28,510.05,256.06,396.31,2,256,2ZM31.14,161.07A244,244,0,0,1,500,253H424.46a5,5,0,0,0-4.35,2.53l-1.5,2.65-3,0v-5l3.48-.06c0-1.68-.09-3.39-.17-5.08l-3.31.16v-5l3-.23c-.13-1.67-.29-3.37-.48-5.06l-2.51.28v-5l1.88-.26c-.24-1.67-.5-3.36-.79-5l-1.09.19v-5.15l.14,0c0-.21-.1-.43-.14-.64V127.59a28.4,28.4,0,1,0-56.8,0V266L348.76,273,322.58,139.75a5,5,0,0,0-5-4,5,5,0,0,0-4.86,4.2l-5.47,33.53a66.63,66.63,0,0,0-62.4-23.11L236.65,53.4a5,5,0,0,0-9.93-.29L210.18,167.66a66.6,66.6,0,0,0-11.87,82.12l-5.91,40.94a5.07,5.07,0,0,0,.21,2.27h-9.05a4.89,4.89,0,0,0,.1-2.79L155.85,181a5,5,0,0,0-4.74-3.76H151a5,5,0,0,0-4.79,3.56l-23,76.59L104,216.58a5,5,0,0,0-4.49-2.87h0a5,5,0,0,0-4.5,2.81l-15.41,31.8H12.09A242,242,0,0,1,31.14,161.07ZM415.81,263.16l-.16.29v-.3ZM319.23,430.65H196.17a4.2,4.2,0,0,0,.05-.51V362.27a5,5,0,0,0-10,0v67.87a4.2,4.2,0,0,0,.05.51h-36a4.2,4.2,0,0,0,0-.51V321.39a18.42,18.42,0,0,1,18.4-18.4h63.72a27.68,27.68,0,0,0,18.6,15.45,5,5,0,0,0,2.68.79l.42,0a4.81,4.81,0,0,0,.68-.13,26.22,26.22,0,0,0,2.67.15A27.59,27.59,0,0,0,282.57,303h38.56a5,5,0,0,0,2.83-.88l24.14-16.57h0l18.55-12.74a5,5,0,0,0,2.17-4.12V127.59a18.4,18.4,0,1,1,36.8,0V295.45l-84.43,61.86a5,5,0,0,0-2,4v68.8A4.2,4.2,0,0,0,319.23,430.65ZM256,159.39a56.79,56.79,0,1,1-56.79,56.79A56.86,56.86,0,0,1,256,159.39Zm-34.47-.4,8.85-61.24,4.66,55A66.24,66.24,0,0,0,221.53,159Zm93.87,26.72L318.13,169l21.65,110.16L319.58,293H297.9l4.74-29.07a66.59,66.59,0,0,0,12.76-78.21ZM291,273l-3.25,20h-8.65a2.4,2.4,0,0,0-.28,0,4.53,4.53,0,0,0-.53.05l-.47.1a4.11,4.11,0,0,0-.46.15,3.57,3.57,0,0,0-.45.19,3.3,3.3,0,0,0-.41.23,3.51,3.51,0,0,0-.4.27l-.37.31a2.57,2.57,0,0,0-.33.33,3.68,3.68,0,0,0-.31.38,3.62,3.62,0,0,0-.27.41c-.08.13-.16.27-.23.41s-.14.33-.2.5-.07.17-.1.26a17.53,17.53,0,0,1-16,12.58L256.12,283A66.43,66.43,0,0,0,291,273Zm-42.95,33.41a17.49,17.49,0,0,1-7.34-9.83,2.6,2.6,0,0,0-.1-.25,4.34,4.34,0,0,0-.2-.5c-.07-.14-.14-.28-.22-.42s-.17-.27-.27-.4-.2-.26-.31-.38l-.33-.33a3.68,3.68,0,0,0-.38-.31,2.7,2.7,0,0,0-.39-.27,4.36,4.36,0,0,0-.42-.23,3.43,3.43,0,0,0-.44-.19,4.42,4.42,0,0,0-.48-.15l-.45-.1a4.93,4.93,0,0,0-.54-.05l-.27,0H202.1a7.35,7.35,0,0,0,.2-.84l4.46-30.9a66.68,66.68,0,0,0,39.26,21ZM480.87,351a244.22,244.22,0,0,1-449.73,0A242,242,0,0,1,12,258.32H82.71a5,5,0,0,0,4.5-2.82l12.21-25.19,20.27,43.1a5,5,0,0,0,9.31-.68l21.6-71.83L174,292.67c0,.11.08.21.11.32h-5.33a28.43,28.43,0,0,0-28.4,28.4V430.14c0,.18,0,.34.05.51H109.5v10h293v-10H329.13a4.2,4.2,0,0,0,.05-.51V363.87l76.2-55.82q-.54,1.56-1.11,3.09l4.69,1.75c.58-1.57,1.15-3.18,1.69-4.79L407,306.86l5-3.66.2.06c0-.09.05-.18.08-.27l1.32-1a5,5,0,0,0,2-4v-8.24c.09-.42.18-.84.26-1.26l-.26-.06v-4.69l.23-.41,1,.16c.15-.85.29-1.72.42-2.59L427.38,263h72.56A242,242,0,0,1,480.87,351Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 254.1,
    y: 342.02,
    width: 6.85,
    height: 6.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 254.1,
    y: 354.81,
    width: 6.85,
    height: 6.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 254.1,
    y: 367.61,
    width: 6.85,
    height: 6.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.08,336.64l4.29,2.55c.86-1.44,1.71-2.92,2.53-4.4l-4.38-2.42C393.73,333.8,392.91,335.24,392.08,336.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381,352.9l3.95,3.07c1-1.33,2.06-2.69,3.05-4.06L384,349C383,350.29,382,351.62,381,352.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386.79,344.94l4.13,2.82c.95-1.39,1.89-2.82,2.79-4.24l-4.21-2.69C388.62,342.21,387.71,343.6,386.79,344.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.72,360.49l3.75,3.3c1.11-1.25,2.22-2.55,3.3-3.86l-3.86-3.18C376.87,358,375.79,359.27,374.72,360.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.84,328l4.45,2.28c.76-1.49,1.52-3,2.24-4.55L399,323.61C398.31,325.09,397.58,326.57,396.84,328Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.05,319.12l4.58,2c.68-1.55,1.34-3.12,2-4.69L403,314.58C402.34,316.09,401.7,317.62,401.05,319.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368,367.67l3.54,3.53c1.18-1.18,2.37-2.41,3.53-3.65l-3.65-3.42C370.28,365.33,369.13,366.52,368,367.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337,391.84l2.57,4.29c1.44-.86,2.89-1.76,4.31-2.67l-2.7-4.21C339.84,390.13,338.43,391,337,391.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.26,380.72l3.07,3.94c1.34-1,2.67-2.12,4-3.19l-3.2-3.84C355.84,378.67,354.55,379.71,353.26,380.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.82,374.42l3.32,3.75c1.25-1.11,2.51-2.27,3.75-3.43l-3.43-3.64C363.26,372.23,362,373.35,360.82,374.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.32,386.53l2.82,4.13c1.39-1,2.78-1.94,4.15-2.94l-3-4C348,384.65,346.66,385.61,345.32,386.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.8,98l-.19-5c-1.68.07-3.39.16-5.07.28l.35,5C246.52,98.12,248.17,98,249.8,98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280,94.61c-1.67-.25-3.36-.47-5-.67l-.58,5c1.63.19,3.27.4,4.89.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.91,119.84c-1.41-.94-2.85-1.86-4.28-2.74L339,121.36c1.39.85,2.78,1.74,4.15,2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.27,114.5c-1.46-.84-3-1.67-4.44-2.46l-2.36,4.4c1.44.78,2.89,1.58,4.3,2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.31,109.71c-1.5-.75-3.05-1.48-4.59-2.18l-2.07,4.55c1.49.68,3,1.39,4.44,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.2,125.7c-1.35-1-2.73-2-4.1-3l-2.89,4.08c1.33.94,2.67,1.91,4,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,97.85c1.22,0,2.44,0,3.66,0l.11-5c-1.25,0-2.51,0-3.77,0h-1.31l0,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.07,105.49c-1.56-.65-3.14-1.29-4.71-1.89l-1.79,4.67c1.52.58,3.06,1.2,4.57,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.89,98.82c-1.62-.45-3.28-.88-4.92-1.29l-1.19,4.86c1.59.39,3.19.81,4.76,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.92,93.44c-1.68-.15-3.38-.26-5.07-.35l-.27,5c1.64.09,3.29.2,4.92.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290,96.4c-1.66-.35-3.34-.68-5-1l-.88,4.92c1.6.29,3.23.6,4.83.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.58,101.85c-1.58-.55-3.21-1.08-4.82-1.59L303.27,105c1.56.49,3.13,1,4.67,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.34,130.82l-3.06-4c-1.33,1-2.66,2.1-4,3.17l3.18,3.86C156.76,132.85,158.05,131.82,159.34,130.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.3,125l-2.8-4.13c-1.4.94-2.79,1.92-4.16,2.91l2.94,4.05C164.6,126.91,166,126,167.3,125Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.74,137.08l-3.29-3.76c-1.27,1.11-2.54,2.26-3.77,3.41l3.42,3.65C149.29,139.27,150.52,138.15,151.74,137.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.61,119.78l-2.55-4.31c-1.44.86-2.9,1.75-4.32,2.65l2.68,4.23C172.8,121.47,174.21,120.61,175.61,119.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.55,143.79,141,140.25c-1.19,1.18-2.39,2.4-3.55,3.63l3.63,3.44C142.24,146.12,143.4,144.94,144.55,143.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.25,107.22l-1.7-4.7c-1.58.57-3.18,1.17-4.74,1.79l1.84,4.65C199.17,108.36,200.71,107.77,202.25,107.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.11,110.85l-2-4.59c-1.54.67-3.09,1.37-4.62,2.09l2.14,4.52C190.11,112.18,191.62,111.49,193.11,110.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.22,115,182,110.58c-1.49.77-3,1.56-4.48,2.38l2.41,4.38C181.32,116.55,182.78,115.78,184.22,115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.55,201.33l-4.69-1.73c-.58,1.59-1.15,3.2-1.68,4.8l4.74,1.58C106.44,204.43,107,202.87,107.55,201.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.25,192.2l-4.58-2c-.68,1.54-1.34,3.12-2,4.68l4.64,1.87C109.94,195.22,110.59,193.69,111.25,192.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.59,104.17l-1.4-4.8c-1.62.47-3.25,1-4.85,1.5l1.55,4.75C208.44,105.12,210,104.63,211.59,104.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.51,183.31l-4.44-2.3c-.78,1.5-1.54,3-2.27,4.55l4.51,2.16C114,186.25,114.75,184.77,115.51,183.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.64,166.43l-4.12-2.83c-.94,1.37-1.89,2.79-2.81,4.22l4.2,2.71C123.8,169.15,124.72,167.77,125.64,166.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.47,158.5l-3.93-3.09c-1.05,1.34-2.08,2.7-3.07,4.05l4,3C129.46,161.11,130.46,159.79,131.47,158.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.79,150.94l-3.74-3.32c-1.12,1.26-2.24,2.55-3.32,3.85l3.84,3.2C135.62,153.42,136.7,152.17,137.79,150.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.31,174.71,116,172.14c-.87,1.43-1.72,2.91-2.55,4.4l4.36,2.44C118.65,177.54,119.48,176.1,120.31,174.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.87,258.55l-5,.08c0,1.7.08,3.41.16,5.07l5-.23C98,261.85,97.9,260.2,97.87,258.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.32,297.4l-4.82,1.3c.44,1.63.91,3.27,1.4,4.88l4.78-1.46C104.21,300.56,103.75,299,103.32,297.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.05,287.83l-4.89,1c.34,1.66.7,3.33,1.09,4.95l4.86-1.15C101.74,291.06,101.38,289.44,101.05,287.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.18,306.8l-4.73,1.61c.54,1.6,1.12,3.21,1.71,4.78l4.68-1.76C107.27,309.91,106.71,308.35,106.18,306.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.87,329.38c-.76-1.44-1.51-2.92-2.22-4.39l-4.5,2.18c.74,1.52,1.51,3,2.29,4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.63,316l-4.62,1.9c.64,1.57,1.31,3.14,2,4.66l4.56-2C110.91,319.05,110.26,317.53,109.63,316Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.57,365l3.72-3.34c-1.08-1.2-2.17-2.45-3.24-3.72l-3.82,3.23C132.33,362.44,133.46,363.72,134.57,365Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.39,278.14l-5,.7c.23,1.66.49,3.34.78,5l4.93-.85C99.87,281.39,99.61,279.75,99.39,278.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.33,268.37l-5,.39c.13,1.67.29,3.37.47,5.05l5-.54C98.61,271.64,98.45,270,98.33,268.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,357.2l3.92-3.11c-1-1.27-2-2.58-3-3.9l-4,3C125.94,354.53,127,355.89,128,357.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122,349.05l4.1-2.86c-.92-1.33-1.85-2.7-2.74-4.08l-4.2,2.73C120.06,346.26,121,347.67,122,349.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.43,340.54l4.28-2.6c-.85-1.39-1.69-2.82-2.49-4.24l-4.35,2.46C114.69,337.62,115.56,339.1,116.43,340.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.94,250.52l-5-.17c0,1.06-.07,2.13-.08,3.2l5,.08C97.88,252.59,97.91,251.55,97.94,250.52Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntensidadPercibidaBlanco);
export default __webpack_public_path__ + "static/media/intensidad_percibida_blanco.a394be0a3dee1204403964e88c2d34dd.svg";
export { ForwardRef as ReactComponent };